import React, { Fragment, ReactNode } from "react";
import { VpMenu } from "../../../../common/component/menu/vp-menu";
import { VpMenuContextProvider } from "../../../../common/component/menu/vp-menu-context";
import { Header } from "../../../../common/component/header/header";
import { HeaderWidgetGroup } from "../../../../common/component/header/header-widget-group";
import { Breadcrumbs } from "../../../../common/component/breadcrumbs/breadcrumbs";
import { FrontendBreadcrumbsBuilder } from "../../../../common/component/breadcrumbs/frontend-breadcrumbs-builder";
import { LanguageSelector } from "../../../../common/component/language-selector/language-selector";
import { UserAccountWidget } from "../../user-account-widget/user-account-widget";
import { useSrmAuthenticatedContext } from "../srm-sso-authentication/srm-authentication-context";

export const SrmBlueReturnsLayout = ({ children }: { children: ReactNode }) => {
    const { userName, logout } = useSrmAuthenticatedContext();

    return <div className="pageView">
        <div className="operationMenu">
            <VpMenuContextProvider>
                <VpMenu menuItemList={[]}>
                    <Fragment />
                </VpMenu>
            </VpMenuContextProvider>
        </div>
        <div className={`page-paper`}>
            <div className={"pageHeader"}>
                <Header>
                    <HeaderWidgetGroup>
                        <Breadcrumbs builder={new FrontendBreadcrumbsBuilder()} />
                    </HeaderWidgetGroup>
                    <HeaderWidgetGroup>
                        <LanguageSelector withoutContext />
                        <UserAccountWidget name={userName}
                                           logoutText={"Logout"}
                                           onLogout={logout} />
                    </HeaderWidgetGroup>
                </Header>
            </div>
            <div className={"page-content__wrapper"}>
                {children}
            </div>
        </div>
    </div>;
};
